import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const SiteContentContext = createContext({ content: {}, loading: true, refresh: async () => {} });

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-content");
      setContent(data || {});
    } catch (e) {
      console.warn("Failed to load site content", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);

/**
 * Returns the content object for a given section key, falling back to provided defaults.
 * Missing nested keys fall back to defaults[key].
 */
export const useContent = (sectionKey, fallback = {}) => {
  const { content } = useSiteContent();
  const section = content[sectionKey] || {};
  return { ...fallback, ...section };
};
